import API_SIM from "@/api/Sim"
import {tipmessage} from "../../utils";
//state
const state = {
   count: 0,//总卡数
   activedCount: 0,//激活总数
   useingCount: 0,//正常在用数量
   noActiveCount: 0,//未激活数量
   testedCount: 0,//测试正常数量
   testErrorCount: 0,//测试不正常数量
   stopedCount : 0,//已停机数量
   logOffCount : 0,//已注销数量
   unKnowCount : 0, //未知的数量
   expireCount : 0, //到期数量
   unExpireCount: 0, //未到期数量
   billgroup: 0//计费组
}
//mutation
const mutations = {
  SET_COUNT(state,count){
    state.count = count;
  },
  SET_ACTIVED(state,count){
    state.activedCount = count;
  },
  SET_USEING(state,count){
    state.useingCount = count;
  },
  SET_NOACTIVE(state,count){
    state.noActiveCount = count;
  },
  SET_TEST(state,count){
    state.testedCount = count;
  },
  SET_TESTERROR(state,count){
    state.testErrorCount = count;
  },
  SET_STOP(state,count){
    state.stopedCount = count;
  },
  SET_LOGOUT(state,count){
    state.logOffCount = count;
  },
  SET_UNKNOW(state,count){
    state.unKnowCount = count
  },
  SET_EXPIRE(state,count){
    state.expireCount = count;
  },
  SET_UNEXPIRE(state,count){
    state.unExpireCount = count;
  },
  SET_BILLGROUP(state,billgroup){
    state.billgroup = billgroup;
  }
}

//action
const actions = {
  getCpy({commit}) {
    console.log(commit)
  },
  getSimCardDetailInfo({commit}){
    return new Promise((resolve,reject) => {
      API_SIM.FETCH_HOMEPAGE().then((res) => {
        let usage = res.result[0];
        //如果usage返回的数据为空则不渲染
        usage.forEach(item => {
          if(item.name === "SIM卡总数"){
            commit("SET_COUNT",item.val);
          };
          if(item.name === "已激活总数"){
            commit("SET_ACTIVED",item.val);
          }
          if(item.name === "计费组"){
            commit("SET_BILLGROUP",item.val);
          }
        });
        //SIM 卡状态 =>>>
        let simstatus = [];
        let color = ["#2e86de","#2ed573","#eccc68","#2f3640","#fa5151","#ccc"];
        // let itemcolor = new Map([['正常', "#70a1ff"],["待激活","#2ed573"],["测试正常","#eccc68"],["销号","#2f3640"],["停机","#fa5151"],["未知","#ccc"]]);//正常、待激活、测试正常、销号、停机、未知
        res.result[1].forEach((item,index) => {
           let status = {};
           status.name = item.name;
           status.value = item.val;
           if(item.name == "正常") {
              status.sim_status = 0;
           }else if(item.name == "待激活") {
              status.sim_status = 1;
           }else if(item.name == "测试正常") {
              status.sim_status = 2;
           }else if(item.name == "销号") {
              status.sim_status = 3;
           }else if(item.name == "停机") {
              status.sim_status = 4;
           }else if(item.name == "待激活") {
              status.sim_status = 5;
           }
           status.itemStyle = {
               color: color[index]
           }
           simstatus.push(status);
           status = null;
        })
        res.result[1] = simstatus;
        // 流量Top5
        let traffictop5 = {};
        traffictop5.xaxisList = [];
        traffictop5.yaxisList = [];
        traffictop5.rawList = [],
        traffictop5.rawList = res.result[2][0].val;
        res.result[2][0].val.forEach((item,index) => {
          traffictop5.xaxisList.push(item.msisdn);
          traffictop5.yaxisList.push(item.flow_use);
        })
        res.result[2] = traffictop5;

        //流量告警Top5
        let alertTop5 = {};
        alertTop5.trafficAlertTop5 = [];
        alertTop5.rawAlertTop5 = res.result[3][0].val;
        res.result[3][0].val.forEach((item) => {
            let alert = {};
            alert.flow_over = item.flow_over;
            alert.flow_use = item.flow_use;
            alert.msisdn = item.msisdn;
            alertTop5.trafficAlertTop5.push(alert);
            alert = null;
        })
        res.result[3] = alertTop5;
        // 过期状态 =>>>
        let simexpire = [];
        let expirecolor = ["#fa5151","#07c160"];
        res.result[4].forEach((item,index) => {
          let expire = {};
          expire.name = item.name;
          expire.value = item.val;
          expire.itemStyle = {
            color: expirecolor[index]
          }
          simexpire.push(expire);
          expire = null;
        })
        res.result[4] = simexpire;
        resolve(res.result);
      },(err) => {
        console.log("获取错误");
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/simControl.js